const _apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/app/campaigns-v2/list',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/trackers',
    locale: 'en',
    // The MirageJS mock server replaces window.fetch and XMLHttpRequest process
    // wide, and answers any relative /api/* path it has a route for — which in a
    // production build meant real users were served the template's seed data
    // (e.g. the header notification bell). Development only.
    enableMock: process.env.NODE_ENV === 'development',
    apiUrl: _apiUrl,
    // Base URL for v2 endpoints — strips the /v1 suffix so callers can append /v2/...
    apiUrlV2: _apiUrl.replace(/\/v\d+$/, ''),
    env: process.env.REACT_APP_ENV || 'dev',
    talkJsAppId: process.env.REACT_APP_TALKJS_APP_ID,
    paypalClientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
    geminiApiKey: process.env.REACT_APP_GEMINI_API_KEY || ''
}

export default appConfig
